module.exports = __webpack_public_path__ + "static/assets/3f38375d60adfb21ae5ba584fd14d1a2.svg";